import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { EGameStatus, ERoleTypes, getPlayerGameStateString, } from "../../../types";
import maleAvatar from "../../../../public/img/man.png";
import femaleAvatar from "../../../../public/img/woman.png";
import blur from "../../../../public/img/blur.png";
import MafiaIcon from "../MafiaIcon/MafiaIcon";
import { positions } from "../../../types";
import { StarterIcon } from "../StarterIcon";
import { useAppSelector } from "../../../hooks";
import { selectMatchState } from "../../../store/match";
import { useEffect, useState } from "react";
const Wrapper = styled.div `
  position: absolute;
  top: ${(props) => positions[props.position].x}px;
  left: ${(props) => positions[props.position].y}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  overflow: visible;

  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
`;
const ImageWrapper = styled.div `
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  box-sizing: border-box;
  overflow: visible;

  background-color: rgba(255, 255, 255, 0.04);
  border: 3px solid;
  border-color: ${(props) => {
    if (props.withBlueColor) {
        return "rgba(0, 241, 227, 1)";
    }
    else if (props.haveBlur) {
        return "rgb(187, 118, 118)";
    }
    else {
        return "rgba(64, 64, 64, 1)";
    }
}};
  border-radius: 50%;
`;
const Avatar = styled.img `
  position: relative;
  z-index: 2;
  display: block;
  width: 84px;
  height: 84px;
  object-fit: cover;
  object-position: center;

  border-radius: 50%;

  box-shadow: 0px 0px 10.77px 0px rgba(0, 0, 0, 0.64);
  ${(props) => (props.selected ? "" : "filter: grayscale(100%);")}
`;
const CurrentPlayerWrapper = styled.div `
  position: absolute;
  z-index: 1;
  width: 121px;
  height: 121px;

  background-image: url(${blur});
`;
const VoteTargetWrapper = styled.div `
  position: absolute;
  inset: 0;

  border-radius: 50%;
  background-color: rgba(213, 53, 53, 1);
`;
const VoteCounter = styled.div `
  position: absolute;
  inset: 3px;
  z-index: 2;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.64);

  font-size: 32px;
  line-height: 40px;
  font-weight: 800;
  color: #fff;
`;
const Text = styled.div `
  max-width: 100px;

  font-size: 14px;
  font-weight: 500;
  color: #fff;
  text-align: center;
`;
const RoleText = styled.p `
  max-width: 100px;
  margin: 0;

  font-size: 10px;
  font-weight: 700;
  color: rgba(65, 236, 82, 1);
  text-align: center;
  line-height: 12px;
`;
const PlayerCard = ({ player, voteTarget, selected, showRoles, currentStatus, onClick, position, isCurrent, roundStarter, haveVotes, votesCount, selectedPlayer, }) => {
    var _a;
    const matchState = useAppSelector(selectMatchState);
    const candidates = ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.candidates) || [];
    const [voteCount, setVoteCount] = useState(0);
    useEffect(() => {
        setVoteCount(votesCount(player.id));
    });
    const { id, team, roleName } = player;
    const { gameName, photoUrl } = player.player;
    const isMafia = team === ERoleTypes.MAFIA;
    const withBlueColor = (((matchState === null || matchState === void 0 ? void 0 : matchState.gameStatus) === EGameStatus.SELECT_DIRECTION_OF_INTRODUCE &&
        candidates.some((item) => (item === null || item === void 0 ? void 0 : item.id) === player.id)) ||
        ((matchState === null || matchState === void 0 ? void 0 : matchState.gameStatus) === EGameStatus.SELECT_DIRECTION_OF_VOTE &&
            candidates.some((item) => (item === null || item === void 0 ? void 0 : item.id) === player.id)) ||
        ((matchState === null || matchState === void 0 ? void 0 : matchState.dayNumber) === 1 &&
            (matchState === null || matchState === void 0 ? void 0 : matchState.gameStatus) === EGameStatus.SELECT_WHO_START_INTRODUCE)) &&
        !selectedPlayer;
    // const haveBlur = isCurrent || selectedPlayer?.id === player.id && !voteTarget && (matchState?.gameStatus === EGameStatus.SELECT_DIRECTION_OF_VOTE && selectedPlayer.id === player.id);
    const haveBlur = () => {
        if (isCurrent) {
            return true;
        }
        if ((selectedPlayer === null || selectedPlayer === void 0 ? void 0 : selectedPlayer.id) === player.id && !voteTarget) {
            return true;
        }
        if ((matchState === null || matchState === void 0 ? void 0 : matchState.gameStatus) === EGameStatus.SELECT_DIRECTION_OF_VOTE &&
            (selectedPlayer === null || selectedPlayer === void 0 ? void 0 : selectedPlayer.id) === player.id) {
            return true;
        }
        return false;
    };
    Avatar.defaultProps = {
        src: photoUrl
            ? photoUrl
            : player.player.gender === "MALE"
                ? maleAvatar
                : femaleAvatar,
    };
    const publicStatuses = () => {
        return Object.values(getPlayerGameStateString(player.state)).filter((item) => item === "Затычка" || item === "В тюрьме" || item === "Иммунитет");
    };
    const privateStatuses = () => {
        return Object.values(getPlayerGameStateString(player.state)).filter((item) => item === "Заминирован" || item === "Защищен леди");
    };
    return (_jsxs(Wrapper, Object.assign({ onClick: () => onClick(id), position: position }, { children: [_jsxs(ImageWrapper, Object.assign({ haveBlur: haveBlur(), withBlueColor: withBlueColor }, { children: [_jsx(Avatar, { selected: selected }), haveBlur() && _jsx(CurrentPlayerWrapper, {}), voteTarget &&
                        (matchState === null || matchState === void 0 ? void 0 : matchState.gameStatus) !== EGameStatus.SELECT_DIRECTION_OF_VOTE && (_jsx(VoteTargetWrapper, {})), isMafia && showRoles && _jsx(MafiaIcon, {}), roundStarter && _jsx(StarterIcon, {}), haveVotes && _jsx(VoteCounter, { children: voteCount })] })), _jsx(Text, { children: gameName }), showRoles && _jsx(RoleText, { children: roleName }), publicStatuses().length > 0 && (_jsx(RoleText, { children: publicStatuses().join(", ") })), showRoles && _jsx(RoleText, { children: privateStatuses().join(", ") })] })));
};
export default PlayerCard;
